import { Directive,  HostListener } from '@angular/core';

@Directive({
    standalone: false,
	selector: 'input[numbersOnly]'
})

export class OnlyNumberDirective {

	constructor() { }

    key;
    @HostListener('keypress', ['$event']) onKeypress(event: KeyboardEvent) {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          return false;
        }
        return true;
    }

}